module.exports = __webpack_public_path__ + "static/media/advantage3.d237ddb4.png";